export const oldToNew = {
  "Business Insights": "Insights",
  Products: "Products",
  "Demand Synchronization": "Demand",
  "Inventory Placement": "Inventory",
  "Production Planning": "Operations",
  "Procurement Planning": "Sourcing",
  "Data Processing": "Upload",
};
